import React from 'react';
import { FiMap, FiWifi, FiPlusCircle, FiList, FiUsers, FiBarChart2, FiFileText, FiSettings, FiLogOut, FiX } from 'react-icons/fi';
import './Sidebar.css';

const Sidebar = ({ menuOpen, setMenuOpen, currentView, onNavigate, onLogout, user, onOpenRedesSociais }) => {
  return (
    <>
      <div className={`sidebar ${menuOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <h2>Sys Conect</h2>
          <button className="toggle-btn" onClick={() => setMenuOpen(false)} aria-label="Fechar menu">
            <FiX />
          </button>
        </div>
        <div className="sidebar-content">
          <div className="user-info">
            <p>Olá, {user?.nome || user?.username || 'Usuário'}</p>
          </div>
          <nav className="sidebar-nav">
            <button
              className={`nav-item ${currentView === 'mapa' ? 'active' : ''}`}
              onClick={() => onNavigate('mapa')}
            >
              <FiMap /> Mapa
            </button>
            <button
              className={`nav-item ${currentView === 'status' ? 'active' : ''}`}
              onClick={() => onNavigate('status')}
            >
              <FiWifi /> Status da Antena
            </button>
            <button
              className={`nav-item ${currentView === 'cadastro' ? 'active' : ''}`}
              onClick={() => onNavigate('cadastro')}
            >
              <FiPlusCircle /> Novo Cadastro
            </button>
            <button
              className={`nav-item ${currentView === 'listar' ? 'active' : ''}`}
              onClick={() => onNavigate('listar')}
            >
              <FiList /> Listar Locais
            </button>
            <button
              className={`nav-item ${currentView === 'acessos' ? 'active' : ''}`}
              onClick={() => onNavigate('acessos')}
            >
              <FiUsers /> Acessos
            </button>
            <button
              className={`nav-item ${currentView === 'relatorio-hotspot' ? 'active' : ''}`}
              onClick={() => onNavigate('relatorio-hotspot')}
            >
              <FiBarChart2 /> Relatório Hotspot
            </button>
            <button
              className={`nav-item ${currentView === 'graficos' ? 'active' : ''}`}
              onClick={() => onNavigate('graficos')}
            >
              <FiFileText /> Gráficos
            </button>
            <button
              className="nav-item"
              onClick={onOpenRedesSociais}
            >
              <FiSettings /> Config. Redes Sociais
            </button>
            <button
              className="nav-item logout"
              onClick={onLogout}
            >
              <FiLogOut /> Sair
            </button>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
